import useCitationLogic from "./useCitationLogic";

/**
 * Shared logic hook for both CitationModal and CitationBottomSheet
 * Builds on top of useCitationLogic to add modal-specific handlers
 */
const useCitationModalLogic = ({
  citationNumber,
  citationText,
  fullReferenceText,
  multipleCitations,
  onClose,
  onViewAllReferences,
}) => {
  const citationData = useCitationLogic({
    citationText,
    fullReferenceText,
    multipleCitations,
  });

  const handlers = {
    handleClose: () => {
      if (onClose) onClose();
    },
    handleViewAllReferences: () => {
      if (onViewAllReferences) onViewAllReferences();
      if (onClose) onClose();
    },
  };

  // Standard class names structure for both modal and bottom sheet
  const getClassNames = (styles = {}) => ({
    content: styles?.citationContent || styles?.["citation-full-text"],
    superscript: styles?.citationSuperscript || styles?.["citation-superscript"],
    urlLink: styles?.citationUrlLink || styles?.["citation-url-link"],
    actions: styles?.citationActions || styles?.["citation-actions"],
    pubmedButton: styles?.pubmedButton || styles?.["pubmed-link"],
    pubmedText: styles?.pubmedText || styles?.["pubmed-text"],
    active: styles?.active,
    disabled: styles?.disabled,
    externalIcon: styles?.externalLinkIcon || styles?.["external-link-icon"],
    navigation: styles?.citationNavigation || styles?.["citation-navigation"],
    viewAllButton: styles?.viewAllButton || styles?.["view-all-references-link"],
    viewAllText: styles?.viewAllText || styles?.["view-all-text"],
    viewAllArrow: styles?.viewAllArrow || styles?.["view-all-arrow"],
  });

  return {
    ...citationData,
    ...handlers,
    citationNumber,
    getClassNames,
  };
};

export default useCitationModalLogic;
